import type { TOC } from '@ember/component/template-only';
import GeneralButtonsButtonsPreviousNextSmall from 'lumen/components/general/buttons/buttons-previous-next-small';

interface GeneralDatepickersDatepickerDisabledSignature {
  Args: {
    placeholder: unknown;
  };
}

const GeneralDatepickersDatepickerDisabled = <template>
  {{! @glint-nocheck: not typesafe yet }}
  <div class="flex-date-picker-container flex flex-row">
    <GeneralButtonsButtonsPreviousNextSmall
      @beginReached={{true}}
      @endReached={{true}}
    />
    <div
      class="flex-date-picker-container__placeholder ml-400"
    >{{@placeholder}}</div>
  </div>
</template> satisfies TOC<GeneralDatepickersDatepickerDisabledSignature>;

export default GeneralDatepickersDatepickerDisabled;
